import { useEffect } from 'react'
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux'
import { StartChallenges } from "../../../../redux/screen/startChallenge";
import StartNewChallenge from '../Qna/StartNewChallenge';
import ReachedLimit from '../Qna/component/ReachedLimit';

const StartChallenge = () => {

  const { challengeID } = useParams();
  const dispatch = useDispatch()

  const challengeDetails = useSelector(state => state.StartChallenges)
  const { data: challengeData, loading: missionDetailLoading, status, message } = challengeDetails
  useEffect(() => {
    dispatch(StartChallenges({ challenge_id: challengeID }))
  }, [dispatch, challengeID])

  return (
    <>
      <div>
        {status === 409 ? <ReachedLimit /> : <StartNewChallenge qnaData={challengeData} isLogo={false} />}
      </div>
    </>
  )
}

export default StartChallenge;
